import { Grid } from '@mui/material';
import { useApplicationContext } from '../../../../../context/ApplicationContext/ApplicationContext';
import { useAuthContext } from '../../../../../login/AuthContext';
import { useOrderContext } from '../../../../contexts/Order.context';
import useOrderSummary from '../../../../contexts/hooks/useOrderSummary';
import EditOrderInBrandButton from './EditOrderInBrandButton';
import FinishOrderButton from './FinishOrderButton';
import LoginButton from './LoginButton';
import MoreActionsButton from './MoreActionsButton';
import UnarchiveSuggestedOrderButton from './UnarchiveSuggestedOrderButton';

const OrderSummaryEndActions = () => {
  const summary = useOrderSummary();
  const { loggedin } = useAuthContext();
  const { order } = useOrderContext();
  const { isStore } = useApplicationContext();

  const isSuggested = order?.status === 'SUGGESTED';
  const isSuggestedArchived = isSuggested && order?.archived;
  const hasFinishAction = isSuggested || !!summary?.primaryAction;

  if (isSuggestedArchived) {
    return !isStore ? <UnarchiveSuggestedOrderButton /> : null;
  }

  return (
    <Grid
      container
      spacing={1}
      wrap="nowrap"
      sx={{
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      <Grid>
        <EditOrderInBrandButton />
      </Grid>
      <Grid>
        <MoreActionsButton order={order} disabled={!summary?.moreActions} />
      </Grid>
      {(!loggedin || hasFinishAction) && (
        <Grid
          size={{
            xs: 'grow',
            md: 'auto',
          }}
        >
          {loggedin ? <FinishOrderButton /> : <LoginButton />}
        </Grid>
      )}
    </Grid>
  );
};

export default OrderSummaryEndActions;
